


import React, { useState } from "react";

const gallery = [
  
  {
  image: "/images/Fleet/1.jpeg",
  title: "Innova Cab",
},
{
  image: "/images/Fleet/2.jpeg",
  title: "Innova Cab",
},
{
  image: "/images/Fleet/3.jpeg",
  title: "Innova Cab",
},
{
  image: "/images/Fleet/4.jpeg",
  title: "Innova Cab",
},
// {
//   image: "/images/Fleet/5.jpeg",
//   title: "Innova Cab",
// },
{
  image: "/images/Fleet/6.jpeg",
  title: "Innova Cab",
},
// {
//   image: "/images/Fleet/7.jpeg",
//   title: "Innova Cab",
// },
{
  image: "/images/Fleet/8.jpeg",
  title: "Innova Cab",
},
{
  image: "/images/Fleet/9.jpeg",
  title: "Innova Cab",
},
{
  image: "/images/Fleet/10.jpeg",
  title: "Innova Cab",
},
{
  image: "/images/Fleet/11.jpeg",
  title: "Innova Cab",
},
{
  image: "/images/Fleet/12.jpeg",
  title: "Innova Cab",
},
{
  image: "/images/Fleet/13.jpeg",
  title: "Innova Cab",
},
{
  image: "/images/Fleet/14.jpeg",
  title: "Innova Cab",
},
{
  image: "/images/Fleet/15.jpeg",
  title: "Innova Cab",
},
{
  image: "/images/Fleet/16.jpeg",
  title: "Innova Cab",
},
{
  image: "/images/Fleet/17.jpeg",
  title: "Innova Cab",
},
{
  image: "/images/Fleet/18.jpeg",
  title: "Innova Cab",
},
{
  image: "/images/Fleet/19.jpeg",
  title: "Innova Cab",
},
{
  image: "/images/Fleet/20.jpeg",
  title: "Innova Cab",
},
  {
    image: "/images/Fleet/Innova-Cab.jpg",
    title: "Innova Cab",
  },
  {
    image: "/images/Fleet/Innova-Crysta.jpg",
    title: "Innova Crysta",
  },
  {
    image: "/images/Fleet/Kia-Carens.jpg",
    title: "Kia Carens",
  },
  {
    image: "/images/Fleet/Maruti-Ertiga.jpeg",
    title: "Maruti Ertiga",
  },
  {
    image: "/images/Fleet/Mini-Bus.jpg",
    title: "Mini Bus",
  },
  {
    image: "/images/Fleet/Swift-Dzire.jpg",
    title: "Swift Dzire",
  },
  // {
  //   image: "/images/Fleet/Tempo-Traveller.jpeg",
  //   title: "Tempo Traveller",
  // },
  // {
  //   image: "/images/Fleet/Toyota-Rumion.jpeg",
  //   title: "Toyota Rumion",
  // },
  // {
  //   image: "/images/Fleet/Urbania-Bus.jpg",
  //   title: "Urbania Bus",
  // },

];
const Gallery = () => {
  const [currentIndex, setCurrentIndex] = useState(null);

  const openImage = (index) => {
    setCurrentIndex(index);
  };

  const closeImage = () => {
    setCurrentIndex(null);
  };

  const nextImage = () => {
    setCurrentIndex((prev) =>
      prev === gallery.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? gallery.length - 1 : prev - 1
    );
  };

  return (
    <>
       

 <section className="page-banner">
      <div className="page-banner-container">
        <h2>
          Gallery
        </h2>
      </div>
    </section>
    


      <div className="container py-5">
        <div className="row">
          {gallery.map((item, index) => (
            // <div key={item.id} className="col-lg-4 col-md-6 mb-4">
            //   <div className="gallery-card borderr" onClick={() => openImage(index)}>
            //     <img src={item.image} alt={item.name} />
            //     <h5>{item.name}</h5>
            //   </div>
            // </div>

            <div className="col-lg-4 col-md-6 mb-4" key={index}>
  <div className="fleetCard" onClick={() => openImage(index)}>

    <div className="fleetBadge">
      Shreesha Travels
    </div>

    <div className="fleetImage">
      <img src={item.image} alt={item.name} />
    </div>

    <div className="fleetContent">
      <h4>{item.name}</h4>

      <div className="fleetBottom">
        <span>Comfort Ride</span>

        <button>
          View
          <i className="fas fa-arrow-right"></i>
        </button>
      </div>
    </div>

  </div>
</div>
          ))}
        </div>
      </div>

      {/* LIGHTBOX */}
      {currentIndex !== null && (
        <div className="lightbox">
          <span className="close darkcolorrrr" onClick={closeImage}>✖</span>

          <span className="prev" onClick={prevImage}>❮</span>
          <img
            src={gallery[currentIndex].image}
            alt="preview"
            className="lightbox-img "
          />
          <span className="next" onClick={nextImage}>❯</span>
        </div>
      )}
    </>
  );
};

export default Gallery;